import { render, staticRenderFns } from "./FileInclude.vue?vue&type=template&id=1edac2ce&"
import script from "./FileInclude.vue?vue&type=script&lang=js&"
export * from "./FileInclude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports